<div class="employers">
  <app-breadcrumbs></app-breadcrumbs>
  <!-- Decorative gradients/orbs to match main hero -->
  <svg
    class="hero-orb orb-a"
    viewBox="0 0 400 400"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <radialGradient id="employersOrbGradientA" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#75b6e7" stop-opacity="0.6" />
        <stop offset="100%" stop-color="#75b6e7" stop-opacity="0" />
      </radialGradient>
    </defs>
    <circle cx="200" cy="200" r="200" fill="url(#employersOrbGradientA)" />
  </svg>
  <svg
    class="hero-orb orb-b"
    viewBox="0 0 400 400"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <radialGradient id="employersOrbGradientB" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#ffffff" stop-opacity="0.35" />
        <stop offset="100%" stop-color="#ffffff" stop-opacity="0" />
      </radialGradient>
    </defs>
    <circle cx="200" cy="200" r="200" fill="url(#employersOrbGradientB)" />
  </svg>
  <!-- Subtle wave to transition into the content below (match main) -->
  <svg
    class="hero-wave"
    viewBox="0 0 1440 120"
    preserveAspectRatio="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z"
      fill="#f6f6f6"
    ></path>
  </svg>
</div>

<!-- Title Container -->
<div class="title-container-1">
  <div class="title-container-2">
    <div class="search-text">Voor opdrachtgevers</div>
  </div>
</div>

<!-- Main Content Section - Split Hero -->
<!-- Hero should match the other reveal animations (fade + translate). Reliability is handled in the component logic. -->
<div class="split-hero-wrapper split-hero-wrapper--white animate-on-scroll animate-hidden">
  <section class="split-hero split-hero--image-right" #openingSplitHero>
    <!-- Content -->
    <div class="split-hero__content">
      <span class="eyebrow">Onze aanpak</span>
      <h2 class="split-hero__title">Onze werkwijze</h2>
      <div class="split-hero__text">
        <p>
          Na de analyse van jouw organisatie en de openstaande vacature
          zullen wij beginnen met het zoeken naar de best passende
          professionals in ons netwerk. Wij doen dit op basis van een samen
          opgesteld searchprofiel met de door jou gewenste kwalificaties.
        </p>
        <p>
          Na onze eerste intakegesprekken met kandidaten, ontvang jij de
          profielen van de best passende IT Professional op jouw vacature.
          Vervolgens plannen we voor jou de afspraak in!
        </p>
      </div>
      <button
        #openingCtaButton
        class="apple-cta apple-cta--blue"
        (click)="navigateTo('contact')"
      >
        <span>Neem contact op</span>
        <icon name="navigate_next"></icon>
      </button>
    </div>

    <!-- Image -->
    <div
      #openingImageWrapper
      class="split-hero__image"
      [style.height.px]="openingImageHeight"
    >
      <img
        src="./assets/employers.webp"
        alt="Voor opdrachtgevers"
        loading="lazy"
      />
    </div>
  </section>
</div>

<!-- Circular Recruitment Section -->
<section class="values-section animate-on-scroll animate-hidden">
  <div class="values-container">
    <div class="section-header">
      <span class="eyebrow">Circulair recruitment</span>
      <h2 class="section-title">Onderscheidend recruitment</h2>
      <p class="section-description">
        Blauwtand is de bedenker van het circulair recruitment project,
        dat in 2021 is geïntroduceerd in de markt. Wij onderscheiden ons
        door gebruik te maken van meerdere (ZZP) recruiters & HR
        professionals in een samenwerkingsverband.
      </p>
    </div>

    <div class="values-grid">
      <div class="value-card">
        <div class="value-icon">
          <icon name="autorenew"></icon>
        </div>
        <h3 class="value-title">Tweede kans principe</h3>
        <p class="value-description">
          Kandidaten die niet bij één organisatie passen krijgen een tweede
          kans binnen het circulair recruitment netwerk.
        </p>
      </div>

      <div class="value-card">
        <div class="value-icon">
          <icon name="groups"></icon>
        </div>
        <h3 class="value-title">Breed netwerk</h3>
        <p class="value-description">
          Samenwerking met meerdere recruiters en HR professionals voor
          maximale bereik en kwaliteit.
        </p>
      </div>

      <div class="value-card">
        <div class="value-icon">
          <icon name="speed"></icon>
        </div>
        <h3 class="value-title">Snelle beschikbaarheid</h3>
        <p class="value-description">
          Direct toegang tot een pool van actief zoekende IT specialisten.
        </p>
      </div>

      <div class="value-card">
        <div class="value-icon">
          <icon name="verified"></icon>
        </div>
        <h3 class="value-title">Betere matches</h3>
        <p class="value-description">
          Voor kandidaten betekent het een extra kans op een beter passende
          baan bij uw organisatie.
        </p>
      </div>
    </div>
  </div>
</section>

<!-- Contact CTA Section -->
<section class="contact-cta-section animate-on-scroll animate-hidden">
  <app-cta-block
    eyebrow="Interesse?"
    title="Laten we kennismaken"
    text="Ben jij benieuwd wat Blauwtand voor jouw organisatie kan betekenen? Neem contact op en ontdek hoe wij het verschil kunnen maken."
    buttonLabel="Neem contact op"
    buttonUrl="/contact">
    <div class="contact-methods">
      <a href="mailto:info@blauwtand.com" class="contact-method">
        <div class="contact-method-icon">
          <icon name="email_filled"></icon>
        </div>
        <span>info&#64;blauwtand.com</span>
      </a>
      <a href="tel:+31798080320" class="contact-method">
        <div class="contact-method-icon">
          <icon name="call_filled"></icon>
        </div>
        <span>{{ phoneNumber }}</span>
      </a>
    </div>
  </app-cta-block>
</section>
